// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Accessibility_pageWrapper__j3QKi","pageContainer":"Accessibility_pageContainer__2nXgc","pageSection":"Accessibility_pageSection__3-jUU"};